import * as server from "@/utils/http"

export const _page = params => server.get("/inspect-exception-log/page", params);

